var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-3",attrs:{"fixed":"","color":"#232323"}},[_c('v-spacer'),_c('div',{staticClass:"grey--text"},[_vm._v(" \n      © Maria Danishvar Brown February, April 2017 - "+_vm._s(new Date().getFullYear())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }